import { render, staticRenderFns } from "./hospital-patient-select-search.vue?vue&type=template&id=c23c6cda&"
import script from "./hospital-patient-select-search.vue?vue&type=script&lang=js&"
export * from "./hospital-patient-select-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports